import { Constructor } from '@angular/cdk/table';
import { HostListener } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DialogService } from 'src/app/shared/services/dialog.service';

type WithDeactivateGuardType = {
  canDeactivate(): Observable<boolean>;
  handleBeforeUnload(event: Event): void;
};

type DeactivateGuardRequirementsBase = {
  form: FormGroup;
  _dialogService: DialogService;
};

export function WithDeactivateGuard<
  TBase extends Constructor<DeactivateGuardRequirementsBase>,
>(
  baseClass: TBase,
): {
  new (...args: any[]): WithDeactivateGuardType;
  prototype: WithDeactivateGuardType;
} & TBase {
  return class Processable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    handleBeforeUnload(event: Event): void {
      if (this.form.dirty) {
        event.returnValue = true;
        event.preventDefault();
      }
    }

    canDeactivate(): Observable<boolean> {
      if (this.form.dirty) {
        return this._dialogService
          .openConfirmationDialog(
            {
              title: 'Discard Changes?',
              message:
                'Changes have been made. Are you sure you want to continue without saving them?',
              confirmLabel: 'Yes',
            },
            {
              top: 'calc(80px + 5%)',
            },
          )
          .afterClosed()
          .pipe(filter((actionedResponse) => actionedResponse));
      }
      return of(true);
    }
  };
}
